import { useTheme } from "next-themes"
import { Toaster as Sonner, toast } from "sonner"

const Toaster = ({
  toastOptions: incomingToastOptions = {},
  ...props
}) => {
  const { theme = "system" } = useTheme()
  // Vincent bug #109 (2026-05-08) — Fusion correcte des toastOptions : si un caller
  // (App.js) passe son propre className/classNames, on les MERGE avec les classNames
  // shadcn par défaut, sans les écraser.
  const mergedToastOptions = {
    ...incomingToastOptions,
    classNames: {
      toast:
        "group toast group-[.toaster]:bg-background group-[.toaster]:text-foreground group-[.toaster]:border-border group-[.toaster]:shadow-lg",
      description: "group-[.toast]:text-muted-foreground",
      actionButton:
        "group-[.toast]:bg-primary group-[.toast]:text-primary-foreground",
      cancelButton:
        "group-[.toast]:bg-muted group-[.toast]:text-muted-foreground",
      ...(incomingToastOptions.classNames || {}),
    },
  }

  return (
    <Sonner
      theme={theme}
      className="toaster group"
      toastOptions={mergedToastOptions}
      {...props} />
  );
}

export { Toaster, toast }
